<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body m-3">
                {{ processType.id ? 'İstem Düzenle' : 'Yeni İstem'}}
                <form @submit.prevent="handleSave" class="mt-3">
                  Prompt
                  <div class="form-floating mb-3">

                    <textarea required
                      rows="7"
                      type="text"
                      class="form-control"
                      id="promtInput"
                      v-model="promt"
                    />
                    <label for="workersInput">Prompt</label>
                  </div>

                </form>
                <div class="row  pt-3">
                  <div class="col-6">
                    <a
                      class=""
                      type="button"
                      @click="$emit('close')"
                    >Kapat
                    </a>
                  </div>
                  <div class="col-6 text-end">
                    <button
                      class="btn btn-primary btn-login btn-sm text-white"
                      type="submit" @click="handleSave()"
                      :disabled="submitted"
                    >
                      <span v-if="!submitted">{{ processType.id ? 'Kaydet' : 'Ekle'}} </span>
                      <span
                        v-if="submitted"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  </div>
                </div>
                <div class="mt-3 text-danger">{{ message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { createPrompt, updatePrompt } from "../service/tales";

export default {
  name: "FacilityModal",
  props: {
    postData: String,
    promtType: Number,
    processType: Object
  },
  data: () => ({
    showModal: false,
    submitted: false,
    message: "",
    promt: ""
  }),
  methods: {
    handleSave() {
      if(this.promt.length > 799) {
      this.$notify({
        group: 'foo',
        title: 'Uyarı',
        text: "Prompt en fazla 800 karakter içerebilir."
      })
        return;
      }


      this.message = "";
      this.submitted = true;
      var type = (this.promtType == 1 ? "TALE":"IMAGE")

      if(this.processType.id){
        updatePrompt(this.processType.id, {"content":this.promt}).then((res) => {
          if (res.data.data.id) {
            this.submitted = false;
            this.$store.state.facilityReload = true;
            this.promt = "";
            this.$emit('close')
          } else {
            this.message = this.$t("error." + res.data.message);
            this.submitted = false;
          }
        });
      } else {
        createPrompt(this.postData, type, {"content":this.promt}).then((res) => {
          if (res.data.data.id) {
            this.submitted = false;
            this.$store.state.facilityReload = true;
            this.promt = "";
            this.$emit('close')
          } else {
            this.message = this.$t("error." + res.data.message);
            this.submitted = false;
          }
        });
      }






    },
  },
  mounted() {
    this.promt = ( this.processType.id ? this.processType.content : "" )
  },
  watch: {
    'processType' (){
    this.promt = ( this.processType.id ? this.processType.content : "" )
    }

  }

};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
